'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var activity = require('./activity.js');
var campaign = require('./campaign.js');
var content = require('./content.js');
var multilingual = require('./multilingual.js');
var score = require('./score.js');



exports.ACTIVITY_STATUS = activity.ACTIVITY_STATUS;
exports.isActivityBreakingNews = activity.isActivityBreakingNews;
exports.isActivityCampaign = activity.isActivityCampaign;
exports.isCampaignSchedulingManual = campaign.isCampaignSchedulingManual;
exports.isCampaignSchedulingRandom = campaign.isCampaignSchedulingRandom;
exports.isWikiCard = campaign.isWikiCard;
exports.GAME_TYPE = content.GAME_TYPE;
exports.extractExplanation = content.extractExplanation;
exports.extractGameExplanation = content.extractGameExplanation;
exports.extractImages = content.extractImages;
exports.isGameErrorText = content.isGameErrorText;
exports.isGameMultipleChoiceQuestion = content.isGameMultipleChoiceQuestion;
exports.isGameNoInteraction = content.isGameNoInteraction;
exports.isGameOpenQuestion = content.isGameOpenQuestion;
exports.isGameOrderingCards = content.isGameOrderingCards;
exports.isGamePictureSpot = content.isGamePictureSpot;
exports.isGameSwipingCards = content.isGameSwipingCards;
exports.isPartialGameErrorText = content.isPartialGameErrorText;
exports.isPartialGameMultipleChoiceQuestion = content.isPartialGameMultipleChoiceQuestion;
exports.isPartialGameNoInteraction = content.isPartialGameNoInteraction;
exports.isPartialGameOpenQuestion = content.isPartialGameOpenQuestion;
exports.isPartialGameOrderingCards = content.isPartialGameOrderingCards;
exports.isPartialGamePictureSpot = content.isPartialGamePictureSpot;
exports.isPartialGameSwipingCards = content.isPartialGameSwipingCards;
exports.Languages = multilingual.Languages;
exports.isLanguageCode = multilingual.isLanguageCode;
exports.isBattleScore = score.isBattleScore;
exports.isCampaignScore = score.isCampaignScore;
exports.isWikiScore = score.isWikiScore;
//# sourceMappingURL=index.js.map
